import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const ProjectCard = ({ id, title, category, image, description, services }) => {
  return (
    <motion.div
      whileHover={{ y: -5 }}
      transition={{ duration: 0.2 }}
      className="group"
    >
      <Link to={`/project/${id}`} className="block">
        <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 h-full">
          {/* Image */}
          <div className="relative overflow-hidden aspect-video">
            <img 
              src={image} 
              alt={title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </div>
          
          {/* Content */}
          <div className="p-6">
            {/* Category */}
            <div className="mb-3">
              <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-600 bg-accent-50 rounded-full">
                {category}
              </span>
            </div>
            
            {/* Title */}
            <h3 className="text-xl font-bold text-primary-800 mb-3 group-hover:text-accent-600 transition-colors duration-200">
              {title}
            </h3>
            
            {/* Description */}
            <p className="text-primary-600 text-sm leading-relaxed mb-4">
              {description}
            </p>
            
            {/* Services */}
            <div className="mb-4">
              <div className="flex flex-wrap gap-1">
                {services.slice(0, 3).map((service, index) => (
                  <span 
                    key={index}
                    className="text-xs text-primary-500 bg-primary-50 px-2 py-1 rounded"
                  >
                    {service}
                  </span>
                ))}
                {services.length > 3 && (
                  <span className="text-xs text-primary-400">
                    +{services.length - 3} more
                  </span>
                )}
              </div>
            </div>
            
            {/* View Project Link */}
            <div className="flex items-center text-accent-500 font-semibold text-sm group-hover:text-accent-600 transition-colors duration-200">
              <span>View Project</span>
              <svg 
                className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-200" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProjectCard;
